import { assignInlineVars } from "@vanilla-extract/dynamic";
import { getAssetDimensions, SanityImg } from "../../../../../lib/images.jsx";
import { blockContentStyles as styles, imgRatio } from "../../blockContent.css";

type SanityImageAsset = { _ref: string; _type?: string };

type ImageBlockValue = {
  decorative?: boolean;
  description?: string;
  position?: "left" | "right" | "center";
  image?: { asset?: SanityImageAsset | null };
  /** Legacy images carry the asset directly instead of under `image`. */
  asset?: SanityImageAsset | null;
};

/**
 * ImageBlock renders an image using the provided asset data and optional
 * descriptive details, or a fallback message when no asset is provided.
 */
const ImageBlock = ({ value }: { value: ImageBlockValue }) => {
  const { decorative, description, position, image, asset } = value;

  const calcAsset = image?.asset ?? asset; // Handle legacy images
  if (!calcAsset) return <p className={styles.error}>No image uploaded</p>;

  const calcPos = position ? position : "center";
  const dimensions = getAssetDimensions(calcAsset);

  return (
    <SanityImg
      width={1000}
      asset={calcAsset}
      className={styles.img({ position: calcPos })}
      // feeds the one-screen cap in `blockContent.css.ts`, which can only be
      // applied to the width without distorting the image
      style={
        dimensions
          ? assignInlineVars({
              [imgRatio]: `${dimensions.width / dimensions.height}`,
            })
          : undefined
      }
      decorative={decorative}
      alt={description}
    />
  );
};

export default ImageBlock;
